import { mentionType } from '@aline/common';
import { MarkdownPlugin, remarkMdx } from '@platejs/markdown';
import remarkGfm from 'remark-gfm';

import { serializeMentionToMarkdown } from '../../ChatEditor/ChatEditorMarkdown';
import { isMentionElement } from '../../ChatEditor/ChatEditorMention/utils';
import { tableMarkdownRule } from '../../ChatEditor/table-markdown-rule';

/**
 * Base MarkdownPlugin with support for:
 * - GitHub Flavored Markdown (strikethrough, tables)
 * - MDX (underline via <u> tags)
 * - Mention serialization (mention_input silenced, mentions serialized as links)
 *
 * Empty-paragraph preservation (`preserveEmptyParagraphs`) is not a plugin option — pass it on
 * `serialize` / `deserialize` (see `getEditorMarkdown` and `deserializeMarkdownWithMentions`).
 *
 * For chat-specific usage with additional mention deserialization, use ChatEditorMarkdownPlugin.
 */
export const BaseMarkdownPlugin = MarkdownPlugin.configure({
  options: {
    remarkPlugins: [remarkGfm, remarkMdx],
    rules: {
      // mention_input is the transient @ trigger element — serialize as empty
      mention_input: {
        serialize: () => ({ type: 'text', value: '' }),
      },
      [mentionType]: {
        serialize: node => {
          if (!isMentionElement(node, mentionType)) return { type: 'text', value: '' };
          return serializeMentionToMarkdown(node);
        },
      },
      table: tableMarkdownRule,
    },
  },
});
